import { PayrollSystem } from '$constants'
import {
  XeroAuEmployee,
  transformXeroAuEmployeeAuOnGet,
} from './xeroAuEmployee'
import { XeroNzEmployee } from './xeroNzEmployee'

//PayrollEmployee is a union of available Payroll System Employees that are integrated with Loaded
export type PayrollEmployee = XeroAuEmployee | XeroNzEmployee

// Function to apply transformations to PayrollEmployee object on get
export const transformPayrollEmployeeOnGet = (
  payrollSystem: PayrollSystem | null,
  payrollEmployee: PayrollEmployee
): PayrollEmployee => {
  switch (payrollSystem) {
    case PayrollSystem.XeroAu:
      return transformXeroAuEmployeeAuOnGet(payrollEmployee)
    default:
      return payrollEmployee
  }
}

/**
 * The payroll employee a staff member is linked to, together with the payroll
 * organisation and the venue that owns the link. The owning venue can differ from
 * the active venue when the staff member is paid by a single payroll company.
 */
export interface LinkedPayrollEmployee {
  employee: PayrollEmployee
  organisationName: string | null
  owningVenueId: string
  owningVenueName: string | null
  isManagedByCurrentVenue: boolean
}
